var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-group" }, [
    _c("label", [_vm._v(_vm._s(_vm.title))]),
    _vm._v(" "),
    _c("div", { staticClass: "input-group" }, [
      _c("input", {
        staticClass: "form-control form-control-sm",
        attrs: {
          type: "text",
          placeholder: _vm.placeholder,
          disabled: _vm.disabled,
        },
        domProps: { value: _vm.selectedValue },
        on: {
          input: function ($event) {
            _vm.selectedValue = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "invalid-feedback",
          class: { "d-block": _vm.hasErrors },
          attrs: { role: "alert" },
        },
        [_c("strong", [_vm._v(_vm._s(_vm.errors[0]))])]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }